<template>
    <!--鹰眼地图-->
    <div class="overviewmap-wrap">
        <i :class="['iconfont','overviewmap-close',overviewMapShow?'open':'']" @click="overviewMapShow=!overviewMapShow">
            {{overviewMapShow?'&#xe60f;':'&#xe647;'}}
        </i>
        <div class="overviewmap" id="overviewmap" v-show="overviewMapShow"></div>
    </div>
</template>
<script>
import TMap from "../../components/TMap";
import Feature from 'ol/Feature';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Translate from 'ol/interaction/Translate';
import Collection from 'ol/Collection';
import Polygon from 'ol/geom/Polygon';
import {getCenter,createEmpty,extend as Extentd} from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';

// import _cloneDeep from "lodash/cloneDeep"; // 深拷贝

export default {
    name:"overviewmap",
    props:["mainmap","pipelineLayerData"],
    data(){
        return {
            overviewMapShow:true, // 是否显示鹰眼地图
            pipelineLayer:null, // 管线图层
            overviewMap:null, // 鹰眼地图
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.init();
        })
    },
    methods:{
        // 初始化鹰眼地图
        init(){
            // let that=this;
            var overviewMap=new TMap('overviewmap',[120.349,30.34],18,'emp');

            this.overviewMap=overviewMap;
            var map=this.mainmap;
            var mainview=map.getView();
            var overviewView=overviewMap.getView();

            // 增加缩略图框
            var extent = map.getView().calculateExtent(map.getSize());
            var coor=[[[extent[0],extent[1]],[extent[2],extent[1]],[extent[2],extent[3]],[extent[0],extent[3]],[extent[0],extent[1]]]];
            // 鹰眼中可移动要素
            var polygonFeature = new Feature(new Polygon(coor));
            
            // 鹰眼中可移动图层
            var vectorSource =  new VectorSource({
                features: [polygonFeature]
            });
            var vectorLayer = new VectorLayer({
                source:vectorSource,
                style: new Style({
                    fill: new Fill({color: 'rgba(56,166,230,0.4)'}),
                    stroke: new Stroke({
                        color: 'white', width: 2
                    })
                }),
                zIndex:1000
            });
            overviewMap.addLayer(vectorLayer);

            // 设置主地图和鹰眼图互动,主地图移动，鹰眼地图跟着移动       
            
            // 下面这两个参数，其实是为了解决循环调用的问题，比如同时定义了主地图的分辨率改变事件，和鹰眼地图的分辨率改变事件，
            // 如果不进行区分，在主地图分辨率改变的同时，就应该调用鹰眼，改变鹰眼地图的分辨率
            // 同理在改变鹰眼地图的分辨率的同时也应该改变主地图的分辨率，这就会造成一个循环的调用，出现内存问题
            // 最本质的就是，就是改变主分辩率的时候，只改变一次鹰眼分辨率，在触发鹰眼分辨率改变事件的时候，不要再次触发主地图分辨率事件的改变，
            // 同理在处理鹰眼分别率改变事件的时候也是如此，
            // 还有就是主地图和鹰眼地图的地图中心改变事件也是同样的道理。
            var overviewMapActiveFlag=false;
            var mapActiveFlag=false;
            // 主地图分辨率改变了,鹰眼地图的地图中心也应该跟着改变
            mainview.on("change:center",function(){
                if(!overviewMapActiveFlag&&!mapActiveFlag){
                    overviewMapActiveFlag=true;
                    var extent = map.getView().calculateExtent(map.getSize());
                    var coor=[[[extent[0],extent[1]],[extent[2],extent[1]],[extent[2],extent[3]],[extent[0],extent[3]],[extent[0],extent[1]]]];
                    vectorLayer.getSource().getFeatures()[0].getGeometry().setCoordinates(coor);
                    setTimeout(function(){
                        overviewMap.getView().setCenter(map.getView().getCenter());
                    },300);
                }
                mapActiveFlag=false;
               
            });

            // 鹰眼地图的中心改变了，主地图的中心也应该跟着改变
            overviewView.on("change:center",function(){
                // 激活主地图
                if(!mapActiveFlag&&!overviewMapActiveFlag){
                    mapActiveFlag=true;
                    mainview.setCenter(overviewView.getCenter());
                }
                overviewMapActiveFlag=false;

            });


            // 主地图分辨率改变
            var overChangeFlag=false;
            var mapChangeFlag=false;
            mainview.on("change:resolution",function(){
                if(!overChangeFlag&&!mapChangeFlag){
                    overChangeFlag=true;
                    var zoom=mainview.getZoom();
                    zoom=zoom-3<0?0:zoom-3;
                    overviewMap.getView().setZoom(zoom);

                }
                mapChangeFlag=false;
            });
            // 鹰眼地图分辨率改变
            overviewView.on("change:resolution",function(){
                // 防止重复事件监听，即主地图分辨率改变影响了鹰眼地图分辨率改变，然后再反过来影响，就会造成死循环
                if(!mapChangeFlag&&!overChangeFlag){
                    mapChangeFlag=true;
                    var zoom=overviewView.getZoom();
                    zoom=zoom+3>20?20:zoom+3;
                    mainview.setZoom(zoom);
                }
                overChangeFlag=false;
            });


            // 鹰眼图鼠标样式
            overviewMap.on('pointermove', function () {
                overviewMap.getTargetElement().style.cursor = 'pointer';
            });
            // 鹰眼的事件
            // overviewMap.on("pipelinelayer",function(){
            //     let overPipelineLayer=overviewMap.getLayerByName("pipeline_layer");
            //     if(!that.pipelineLayer&&!overPipelineLayer){
            //         let temp=that.mainmap.getLayerByName("pipeline_layer");
            //         // 为了防止出现地图闪烁的问题，尝试使用深拷贝的方式进行
            //         // 使用深拷贝的方式，会出现无法复制地图的颜色的问题
            //         that.pipelineLayer=_cloneDeep(temp);
            //         // 鹰眼加载管线图层
            //         if(that.pipelineLayer){
            //             overviewMap.addLayer(that.pipelineLayer);
            //         }
            //     }
            // })

            // 鹰眼图点击
            overviewMap.on('click',function(e){
                var coor = e.coordinate;
                map.getView().setCenter(coor);
            });
            // 增加鹰眼地图可移动的事件
            var translateInteraction=new Translate({
                features:new Collection([polygonFeature])
            });
            translateInteraction.on("translateend",function(){
                // 获取图形的中心
                var ext=polygonFeature.getGeometry().getExtent();
                var center=getCenter(ext);
                // 调整主地图的中心
                map.getView().setCenter(center);
            });
            overviewMap.addInteraction(translateInteraction);

            // 增加管道图层
            this.addPipelineLayer();
        },
        // 加载管道图层
        addPipelineLayer(){
            let that=this;
            let data=this.pipelineLayerData;
            // 判断是否数据正常
            if(!data||!data.features||data.features.length<=0){
                return;
            }
            // 加载管线数据
            let geojsonFormat=new GeoJSON();
            let features=geojsonFormat.readFeatures(data);
            //将请求结果保存
            that.pipelineFeatureArray=features;

            //获取管线的实时数据
            // that.getLineRealTimeData();

            //绘制图层
            let vectorSource = new VectorSource({
                format: new GeoJSON(),
            });
            vectorSource.addFeatures(features);
            let vector = new VectorLayer({
                name:"pipeline_layer",
                source: vectorSource,
                zIndex:200,
                minResolution:that.overviewMap.getResolution(20),
                maxResolution:that.overviewMap.getResolution(10),
                style:new Style({
                    stroke: new Stroke({
                        lineCap:"square",
                        width:4,
                        color:"rgb(0, 255, 204)"
                    })
                })
            });
            // 将图层添加到底图上
            that.overviewMap.addLayer(vector);

            //获取管线范围
            let extent=createEmpty();
            let featureArray=features;
            for(let i=featureArray.length-1;i>=0;i--){
                let feature=featureArray[i];
                //存储图形的范围
                let geom=feature.getGeometry();
                extent=Extentd(extent,geom.getExtent());
            }
            //保存图形范围
            that.featureExtent=extent;
            let [x1,y1,x2,y2]=extent;
            that.featureExtent=[x1-0.01,y1-0.01,x2+0.01,y2+0.01];
            //图形缩放到全屏
            that.overviewMap.getView().fit(that.featureExtent,that.mainmap.getSize());
        }
    }
}
</script>
<style lang="scss">
/*鹰眼功能*/
.overviewmap,.overviewmap.ol-uncollapsible
{
    bottom:auto;
    left:auto;
    right:0px;
    bottom:0px;
}
.overviewmap{
    position: absolute;
    right: 0;
    bottom: 0;
    width: 300px;
    height: 180px;
    border:1px solid #333;
    z-index: 11;
    border-radius: 4px;

    .ol-control button {
        font-size: 1rem!important;
    }
    .ol-zoom{
        position: absolute;
        top:10px!important;
        left: 10px!important;
    }
    .ol-control {
        padding: 1px;
        background: #aaa;
    }

    .ol-control button {
        background: #fff;
        color: #000;
        margin: 0;
        font-size: 1.5rem;
        cursor: pointer;
        outline: none;
    }
    .ol-touch .ol-control button{
        font-size:1.5rem;
    }

    .ol-control .zoom-bar-in {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid #aaa;
    }

    .ol-control .zoom-bar-out {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
}
.overviewmap-close.iconfont{
    display: inline-block;
    position: absolute;
    z-index: 12;
    background: #fff;
    padding: 5px 7px;
    border-radius: 3px;
    font-size: 16px;
    cursor: pointer;
    right: 1px;
    bottom: 1px;
}
</style>